const Constants = Object.freeze({
  APPURLS: {
    NOT_FOUND: "/not-found",

    /* PUBLIC URLS */
    OFFERS_CLUB: "/offers-club",
    AFFILIATE_CONSULTATION: "/affiliate-consultation",
    DECEASED_AFFILIATE: "/deceased-affiliate",
    LAST_EXPENSES: "/last-expenses",
  },
  APIURLS: {
    COMPANIESBYCAT: "/api/ClubAmigos/Empresas/ByCodCategoria/", // + codCategoria
    OFFERS: "/api/ClubAmigos/Empresas/Ofertas/", // + codEmpresa
    RELATIVES: "/api/UltimosGastos/Parentescos",
    SAVEINSCRIPTION: "/api/UltimosGastos/Inscripcion",

    ISFALLECIDO: "/api/Afiliado/IsFallecido/", // + cedula
    ISAFILIADO: "/api/Afiliado/publicIsAfiliado/", // + cedula
    ENVIO_EMAIL: "/api/EnvioEmail", // POST: { phoneNumber, name, lastName, email, afiliadoId, templateId }
    GRABAR_BITACORA: "/api/GenericService/QueryLogs", 
  },
  RESOURCESURLS:
  {
     PENSION_SOBREVIVENCIA : "https://afpcrecer.com.do/mis-beneficios/pension-por-sobrevivencia/" 
  }
});

export default Constants;
